import React from 'react';
import { Link } from 'react-router-dom';
import ExtraSection from './ExtraSection';
import AuthService from '../../services/auth-service';
import isValid from '../../utils/is-valid';

import './Login.scss';

const particleConfig = require('./particlesjs-config.json');

export interface ForgetPasswordState {
  phoneNumber: string;
  error: string
}

class ForgetPassword extends React.Component<any, ForgetPasswordState> {

  authService = new AuthService();

  state = {
    phoneNumber: '',
    error: ''
  }

  render() {
    return (
      <div className="login-page-component" id="particle-div">
        <div className="container">
          <div className="row">
            <div className="col-lg-9 col-12 mx-auto login-card-container">
              <div className="login-card">
                <div className="row h-100 w-100 mx-0">
                  <div className="col-lg-6 col-12 h-100">
                    <form className="login-form">
                      <h1 className="login-title">فراموشی رمز عبور</h1>
                      <div className="form-group">
                        <input
                          autoFocus
                          type="text"
                          className="form-control gray-input-text login-input text-center"
                          placeholder="شماره موبایل"
                          onKeyDown={this.handleKeyDown}
                          onChange={this.handlePhoneNumberChange}
                        />
                      </div>
                      {(this.state.error === null) ? '' :
                        <div className="form-group text-danger text-center" style={{ fontSize: '0.9rem' }}>
                          {this.state.error}
                        </div>
                      }
                      <div className="form-group">
                        <button
                          onClick={this.requestTemperoryPassword}
                          className="btn btn-block btn-success">ارسال رمز یکبار مصرف</button>
                      </div>
                      <div className="text-center">
                        <Link to="/login" className="form-note">
                          بازگشت به صفحه ورود <i className="far fa-angle-left"></i>
                        </Link>
                      </div>
                    </form>
                  </div>
                  <ExtraSection />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  componentDidMount() {
    (window as any).particlesJS('particle-div', particleConfig, () => {
      console.log('Particles Load');
    });
  }

  handlePhoneNumberChange = (e: any) => {
    this.setState({ phoneNumber: e.target.value });
  }

  handleKeyDown = (e: any) => {
    if (e.key === 'Enter') {
      this.requestTemperoryPassword(e);
    }
  }

  private requestTemperoryPassword = (e: any) => {
    e.preventDefault();
    const phone = this.state.phoneNumber;
    if (!isValid.phoneNumber(phone)) {
      this.setState({ error: 'شماره موبایل وارد شده نامعتبر است' });
      return;
    }
    this.authService.forgetPassword(phone);
    window.location.href = '/login?forget=true';
  }

}

export default ForgetPassword;
